export enum TidePeak {
  High = 'HIGH',
  Low = 'LOW',
}

export interface ITideMarkerData {
  time: string;
  height: number | string;
  type: `${TidePeak}`;
}

export interface ITideForecast {
  tideData?: ITideMarkerData[];
  maxHeight?: number;
  minHeight?: number;
}
